import React from 'react';
import { Box, Typography } from '@mui/material';

import { ColorPicker } from './color-picker';

interface BrandColorPickerProps {
  label?: string;
  primaryColor?: string;
  onChangePrimaryColor?: (color: string) => void;
}

export const BrandColorPicker = ({
  label,
  primaryColor = '#000000',
  onChangePrimaryColor = () => {},
}: BrandColorPickerProps) => {
  return (
    <>
      {label && (
        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
          <Typography variant="caption">{label}</Typography>
        </Box>
      )}

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box>
          <ColorPicker color={primaryColor} onChange={onChangePrimaryColor} />
        </Box>
      </Box>
    </>
  );
};
